// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-md": () => import("./../../../src/pages/index.md" /* webpackChunkName: "component---src-pages-index-md" */)
}

